import React, { Component } from "react";
import { Link } from "react-router-dom";
export class PageExpired extends Component {

    state = {
        redirected_url : '/'
    };

    componentDidMount() {
        if (localStorage.getItem("user_steps") == 'writing-jobs') {
            this.setState({ redirected_url: "/process/writingjobs" });
        } else if (localStorage.getItem("user_steps") == 'billing') {
            this.setState({ redirected_url: "/process/step3" });
        } else if (localStorage.getItem('user_steps') == null) {
            this.setState({ redirected_url: "/login" });
        }
    }

    render() {
        return (
            <div className="container-fluid" style={{ height: "100vh" }}>
                <div className="row align-items-center justify-content-center h-100">
                    <div className="col-12 col-md-6 col-lg-8 col-xl-4">
                        <div className="text-center">
                            <img className="d-block m-auto" src="/images/timerModal.png" alt="timer" />
                        </div>
                        <h1 className="display-4 text-center mb-3 w-100">
                            This verification link has expired.
                        </h1>
                        <div className="form-group small text-center">
                            To resend an email verification link
							<Link
                                // to={`/account/settings`}
                                to={this.state.redirected_url}
                                className="form-text small text-muted d-inline-flex font-weight-bold text-dark"
                            >
                                Click here
                            </Link>{" "}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PageExpired;



// WEBPACK FOOTER //
// ./src/components/auth/messages/PageExpired.js